const breadCrumb = "Lançamento de Notas - Recuperação e Conselho de Classe";

const routes = [
  {
    path: "/lancar-votos-conselho-classe",
    name: "lancar-votos-conselho-classe",
    meta: {
      allowedPermissions: ["lancamento_notas_turma_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/PermitirLancarVotosConselhoClasse/PermitirLancarVotosConselhoClasseHome.vue"
      ),
  },
  {
    path: "/lancar-votos-conselho-classe/:alunoId/:matriculaId/:disciplinaId",
    name: "lancar-votos-conselho-classe-aluno",
    meta: {
      allowedPermissions: ["lancamento_notas_turma_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/PermitirLancarVotosConselhoClasse/LancarVotosConselhoClasse.vue"
      ),
  },
  {
    path: "/consultar-votos-conselho-classe/:alunoId/:matriculaId/:disciplinaId",
    name: "consultar-votos-conselho-classe-aluno",
    meta: {
      allowedPermissions: ["lancamento_notas_turma_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/PermitirLancarVotosConselhoClasse/ConsultarVotosConselhoClasse.vue"
      ),
  },
];

export default routes;
